import type { DataApp } from '../IntegrationsRecommendation.types'

export const filterSalesApp = (app: DataApp): boolean => {
  return app.recommendations ? app.recommendations.some(({ type }) => type === 'SALES') : false
}
